import React, {useEffect, useMemo, useState} from "react";
import {
    Grid, Typography
} from "@mui/material";
import {Add, ChevronRight} from "@mui/icons-material";
import {Cargo, CargoV2, Service} from "~/apps/packages/auto-visits/queries";
import {useCargoNecessaryServiceListExecutor} from "~/apps/packages/auto-visits/hooks";
import {ServiceSelectDialog} from "~/apps/packages/auto-visits/components/AutoVisitForm/ServiceSelectDialog";
import {CardButton} from "~/apps/core/ui/CardButton";
import {useBooleanHistoryState, useHistoryState} from "~/apps/core/utils";
import {AutoVisitCargoCard} from "~/apps/packages/auto-visits/components/AutoVisitCargoCard";
import {useErrorHandler} from "~/components/ErrorHandling";
import {ConfirmActionDialog} from "~/components/ConfirmActionDialog";
import {OrderItemCargo} from "~/apps/packages/auto-shipment-orders/queries";
import {CargoSelectDialog, CargoSelectDialogProps } from "./CargoSelectDialog";
import {
    OrderCargoCard
} from "~/apps/packages/auto-shipment-orders/components/OrderDetail/OrderCargoCard/OrderCargoCard";
import {CargoWithServices} from "~/apps/packages/auto-visits/components/AutoVisitForm/EditableCargoList";


export type CargoListProps = {
    autoVisitId?: string
    value?: OrderItemCargo[]
    onChange: (value: OrderItemCargo[]) => void
    disabled?: boolean
}


export const CargoList = (props: CargoListProps) => {
    const handleError = useErrorHandler();
    const {value, onChange, disabled: inDisabled} = props;
    const [openSelectDialog, setOpenSelectDialog] = useBooleanHistoryState("selectCargo");

    const [countAppending, setCountAppending] = useState(0);
    const [editCargoID, setEditCargoID, delEditCargoID] = useHistoryState<OrderItemCargo["id"]>({
        name: "cargoID"
    });

    const [cargoToConfirmRemove, setCargoToConfirmRemove] = useState<string>(null);

    const disabled = countAppending > 0 || inDisabled;
    const editCargo: OrderItemCargo = useMemo(() => {
        return value?.find(c => c.id == editCargoID);
    }, [editCargoID, value]);

    const changeCargoList = (cargos: OrderItemCargo[]) => {
        const currentCargoByID = {};
        for (const cargo of value) {
            currentCargoByID[cargo.id] = cargo;
        }
        const nextValue: OrderItemCargo[] = [];
        const newCargos = []

        for (const cargo of cargos) {
            if (currentCargoByID[cargo.id]) {
                nextValue.push(currentCargoByID[cargo.id]);
            } else {
                newCargos.push(cargo);
            }
        }

        let promise = Promise.resolve();

        if (newCargos && newCargos.length > 0) {
            for (let i = 0; i < newCargos.length; ++i) {
                nextValue.push({
                    ...newCargos[i],
                })
            }
        }

        setCountAppending(newCargos?.length);
        promise.then(() => {
            setCountAppending(0);
            onChange && onChange(nextValue);
        }, e => {
            setCountAppending(0);
            handleError(e);
        });
    }

    // закрываем диалог при обновлении страницы
    useEffect(() => {
        if (openSelectDialog) {
            setOpenSelectDialog(false);
        }
    }, [])

    const handleOpenSelectCargoDialogClick = () => {
        setOpenSelectDialog(true).then(() => null);
    }

    const handleSelectCargoDialogClose = () => {
        setOpenSelectDialog(false).then(() => null);
    }

    const handleRemoveCargoClick = (cargo: Pick<OrderItemCargo, "id">) => () => {
        setCargoToConfirmRemove(cargo.id);
    }

    const handleConfirmRemoveCargo = () => {
        changeCargoList(value.filter(x => x.id != cargoToConfirmRemove));
        setCargoToConfirmRemove(null);
    }

    const handleCargoListChange: CargoSelectDialogProps["onChange"] = (cargos) => {
        setOpenSelectDialog(false).then(() => {
            changeCargoList(cargos as OrderItemCargo[]);
        });
    }

    /*const handlerOpenCargoDialogClick = (cargo: OrderItemCargo) => () => {
        setEditCargoID(cargo.ID);
    }*/


    return (
        <Grid direction="column" container wrap="nowrap" spacing={1}>
            <ConfirmActionDialog
                open={cargoToConfirmRemove !== null}
                dialogId={"removeCargo"}
                dialogTitle="Вы хотите удалить груз?"
                confirmButtonText="Подтвердить"
                onClose={() => setCargoToConfirmRemove(null)}
                onConfirm={handleConfirmRemoveCargo}
            >
                <Typography width="100%" align="center" variant="screenText">Вы хотите удалить груз?</Typography>
            </ConfirmActionDialog>
            {value.map(cargo => (
                <Grid item key={cargo.id}>
                    <OrderCargoCard
                        cargo={cargo}
                        deletable
                        //disabled={disabled}
                        onRemoveClick={handleRemoveCargoClick(cargo)}
                    />
                </Grid>
            ))}
            <Grid item>
                <CardButton
                    startIcon={<Add/>}
                    endIcon={<ChevronRight/>}
                    onClick={handleOpenSelectCargoDialogClick}
                    disabled={disabled}
                    fullWidth
                    size="large"
                >
                    Добавить груз
                </CardButton>
            </Grid>

            <CargoSelectDialog
                value={value.map(x => ({
                    id: x.id,
                    tags: x.tags,
                    code: x.code,
                    name: x.name,
                    type: x.type as "Генеральный груз" | "КТК" | "Насыпной груз",
                    description: x.description,
                    arrival: x.arrival,
                    container: x.container
                }))}
                onChange={handleCargoListChange}
                open={openSelectDialog}
                onClose={handleSelectCargoDialogClose}
            />
        </Grid>
    );
}
